<template>
  <a-modal
    :close-on-click-modal="false"
    :visible.sync="visible"
    @cancel="onCancelBtnClick"
    cancelText="关闭"
    width="50vw"
    :z-index="1002">
    <div class="mapMain">
      <iframe id="mapFrame2" :src="iframeUrl" ref="mapFrame2" style="width:100%;height:100%;"></iframe>
    </div>
    <template slot="footer">
      <a-button @click="onCancelBtnClick">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      iframeUrl: ""
    };
  },
  created() {
    this.iframeUrl = process.env.VUE_APP_MAP_API;
  },
  methods: {
    init(coordinate,flag) {
      var that = this;
      this.visible = true;
      this.$nextTick(() => {
        that.iframeUrl = process.env.VUE_APP_MAP_API;
        let mapFrame = that.$refs["mapFrame2"];
        let iframeWin = mapFrame.contentWindow;
        iframeWin.location.href = that.iframeUrl;
        if (coordinate != "") {
          if (mapFrame.attachEvent) {
            //兼容浏览器判断
            mapFrame.attachEvent("onload", function() {
              iframeWin.postMessage(coordinate+"," + flag, "*");
            });
          } else {
            mapFrame.onload = function() {
              iframeWin.postMessage(coordinate+"," + flag, "*");
            };
          }
        }
      });
    },

    onCancelBtnClick() {
      this.visible = false;
    }
  }
};
</script>
<style scoped>
.ant-modal-content .mapMain {
  height: 40vw;
}
</style>


